import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getUploadLimit } from '../lib/settingsApi';
import { getUploadLimitBytes, setUploadLimitBytes } from '../lib/fileUpload';

export const UPLOAD_LIMIT_KEY = ['settings', 'upload-limit'] as const;

/**
 * The single-file upload limit set in Settings → Google Drive, in bytes.
 *
 * Mounted once in the app layout so the shared upload helpers in
 * lib/fileUpload check files against the admin's limit, not the hard cap;
 * upload surfaces call it again to show the number in their hints.
 */
export function useUploadLimit(): number {
  const { data } = useQuery({
    queryKey: UPLOAD_LIMIT_KEY,
    queryFn: getUploadLimit,
    staleTime: 5 * 60_000,
  });
  useEffect(() => {
    if (data) setUploadLimitBytes(data.maxUploadBytes);
  }, [data]);
  return data?.maxUploadBytes ?? getUploadLimitBytes();
}
